import { NFTSState } from '../../types';

const nftsState: NFTSState = {
  nfts: {
    nfts: [],
  },
};

export default nftsState;
